
import { mapGetters } from "vuex";
import ProductListCarouselCardVertical from "./ProductListCarouselCardVertical.vue";
import ProductListCarouselCardHorizontal from "./ProductListCarouselCardHorizontal.vue";
import useProductFilter from "~/mixins/useProductFilter";

export default {
  name: "ProductListCarouselCard",
  components: {
    ProductListCarouselCardVertical,
    ProductListCarouselCardHorizontal,
  },
  mixins: [useProductFilter],
  props: {
    data: {
      type: Object,
      required: true,
    },
    productIndex: {
      type: Number,
      default: 0,
    },
    statisticItemListName: {
      type: String,
      default: "",
    },
    statisticItemListId: {
      type: String,
      default: "",
    },
    isCardVertical: {
      type: Boolean,
      default: false,
    },
    isCardDrawer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardComponent() {
      return this.isCardVertical
        ? "ProductListCarouselCardVertical"
        : "ProductListCarouselCardHorizontal";
    },
    productData() {
      return this.localProduct || this.data;
    },
  },
  watch: {
    data: {
      handler(val) {
        if (val) {
          const sku = val?.variant_plp_image?.sku || val?.default_sku || val?.productSKU;

          this.localProduct = {
            ...val,
            productSKU: sku,
            default_sku: sku,
          };

          // Call setMaterials synchronously to set materials before child components mount
          this.setMaterials();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.data && !this.localProduct) {
      this.localProduct = { ...this.data };
    }
  },
  methods: {
    handleProductAdded() {
      this.$emit("product-added");
    },
  },
};
